<template>
  <div>
    <v-card-actions>
      <v-card-title>SKILLS</v-card-title>
      <v-btn fab small color="info" @click="skillAdd = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card-actions>
    <project-skill-view :project-skill-list="skills"></project-skill-view>
    <project-skill-add
      :skill-add="skillAdd"
      :skill-list="skillList"
      @update-add-skill-modal="updateSkillModal()"
    ></project-skill-add>
  </div>
</template>
<script>
import ProjectSkillAdd from "@/components/Projects/ProjectInnerCardsComp/ProjectSkillAdd";
import ProjectSkillView from "@/components/Projects/ProjectInnerCardsComp/ProjectSkillView";
export default {
  name: "ProjectSkill",
  components: {
    "project-skill-view": ProjectSkillView,
    "project-skill-add": ProjectSkillAdd,
  },
  data() {
    return {
      skillAdd: false,
    };
  },
  props: ["skills", "skillList"],
  methods: {
    updateSkillModal(value) {
      this.skillAdd = value;
    },
  },
};
</script>
